import React, {Component} from 'react';
import {connect} from 'react-redux';
import If from './If';
import {themableImagePath} from '../utils/imageUtils';
import LogoutModal from "./LogoutModal";
import {getExternalDashboardUrl, isDevelopmentMode} from "../utils/configUtils";
import {getHeaderBackgroundClass} from "../utils/themeUtils";
import ThemableComponent from "./theme/ThemableComponent";
import { Trans, useLingui } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { navigate } from '../utils/navigationUtils';

class Header extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showLogoutModal: false,
            route: "",
        };
    }

    handleLogoClick = () => {
        const tradePortalHomeUrl = this.props.authentication?.tradeportal?.homeUrl;
        if (tradePortalHomeUrl) {
            window.location.href = tradePortalHomeUrl;
            return;
        }
        const externalDashboardUrl = getExternalDashboardUrl();
        if(externalDashboardUrl) {
            window.location.href = externalDashboardUrl;
        }
        else {
            navigate("/")
        }
    }

    render() {
        return (
            <header className={`${getHeaderBackgroundClass()} print-hidden`}>
                <div className="container mx-auto">
                    <div className="flex justify-between">
                        <div className="header-logo flex items-center">
                            <img onClick={this.handleLogoClick} src={themableImagePath("logo.svg")} alt="logo" className="h-10 my-4 cursor-pointer"/>
                        </div>
                        <div className="flex items-center text-primary-dark">
                            {isDevelopmentMode() && <LanguageSwitcher/>}
                            <If test={this.props.agency.isAuthenticated}>
                                <div>
                                    {this.props.agency.userName}
                                    <br/>
                                    <button 
                                        className="cursor-pointer hover:underline"
                                        onClick={() => this.onLogoutClick('/logoutAgency/1')}
                                    >
                                        <Trans id="logout">Log out</Trans>
                                    </button>
                                </div>
                            </If>
                            <If test={this.props.authentication.isAuthenticated}>
                                <div className="ml-4">
                                    <If test={isDevelopmentMode()}>
                                        <span className="text-black">
                                            {this.props.authentication.bookingReference}
                                        </span><br/>
                                    </If>
                                    <ThemableComponent
                                        componentName="LogOutButton"
                                        handleClick={() => this.onLogoutClick(t({id: "/logoutUser"}))}
                                    />

                                </div>
                            </If>
                        </div>
                    </div>
                </div>
                <LogoutModal showModal={this.state.showLogoutModal} hideModal={this.hideModal} logout={this.logout}/>
            </header>);
    }

    //--


    onLogoutClick = (route) => {
        if(this.props.isCartEmpty) {
            navigate(route);
            return;
        }

        this.setState({
            showLogoutModal: true,
            route,
        });
    };

    hideModal = () => {
        this.setState({
            showLogoutModal: false,
        });
    };

    logout = () => {
        this.hideModal();
        navigate(this.state.route);
    };
}


function mapStateToProps(state) {
    return {
        authentication: state.authentication,
        agency: state.agency,
        isCartEmpty: state.cart.nrExcursions === 0
    };
}

export default connect(mapStateToProps)(Header);

const LanguageSwitcher = () => {
    const {i18n} = useLingui();
    return(
        <select
            className="mr-4 border rounded px-2 py-1 bg-primary-dark text-white"
            value={i18n.locale}
            onChange={e => {
                i18n.activate(e.target.value);
            }}
            aria-label="Switch language"
        >
            <option value="en">English</option>
            <option value="fr">Français</option>
        </select>
    )
}